import { Grid, makeStyles, Typography } from '@material-ui/core';
import React from 'react';
import Link from '../link';
import ArrowListItem from './arrow-list-item';

type FooterGettingStartedBlockProps = {
  negativeMargin?: number;
};

const useStyles = makeStyles(theme => ({
  container: (props: FooterGettingStartedBlockProps) => ({
    flexGrow: 1,
    background: '#fff',
    boxShadow: '0px 18px 30px rgba(18, 30, 52, 0.15)',
    borderRadius: '20px',
    marginTop: -theme.spacing(props.negativeMargin),
    marginBottom: theme.spacing(10),
  }),

  column: {
    padding: theme.spacing(10),
    [theme.breakpoints.up('md')]: {
      '&:first-child': {
        paddingLeft: theme.spacing(14),
        paddingRight: theme.spacing(0),
      },
      '&:last-child': {
        paddingLeft: theme.spacing(8),
      },
    },

    [theme.breakpoints.between('sm', 'md')]: {
      padding: theme.spacing(8),
      '&:first-child': {
        paddingLeft: theme.spacing(12),
        paddingRight: theme.spacing(0),
      },
    },

    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(4, 8),
      '&:first-child': {
        paddingBottom: 0,
      },
    },
  },

  getStartedText: {
    color: theme.palette.primary.main,
    fontSize: '1.1rem',
    marginBottom: theme.spacing(3),
  },
}));

const FooterGettingStartedBlock: React.FC<FooterGettingStartedBlockProps> = props => {
  const classes = useStyles(props);

  return (
    <Grid container className={classes.container}>
      <Grid item sm={5} className={classes.column}>
        <Typography variant="overline" className={classes.getStartedText}>
          Get Started
        </Typography>
        <Typography variant="h2">Ready to try Architect?</Typography>
      </Grid>
      <Grid item sm={7} className={classes.column}>
        <ArrowListItem style={{ marginTop: '15px' }}>
          <Link styled="true" to="//cloud.architect.io/signup">
            Get started for free
          </Link>
        </ArrowListItem>
        <ArrowListItem>
          See examples on{' '}
          <Link styled="true" to="//github.com/architect-team/architect-cli/tree/master/examples">
            GitHub
          </Link>
        </ArrowListItem>
        <ArrowListItem>
          <Link styled="true" to="/contact-us">
            Contact us
          </Link>{' '}
          for pricing
        </ArrowListItem>
      </Grid>
    </Grid>
  );
};

FooterGettingStartedBlock.defaultProps = {
  negativeMargin: 15,
};

export default FooterGettingStartedBlock;
